import React, { useEffect, useState } from 'react';
import {
  addLitigiuByMeasure,
  deleteLitigiiByMeasure,
  getLitigationUsers,
  getLitigii,
  getLitigiiByMeasure,
  addLitigationUser,
  removeLitigationUser
} from '../../network/litigii';
import { ILitigation } from '../../utils/interfaces/interfaces';
import CButton from '../button/button';
import CDropdown from '../dropdown/dropdown';
import { Space } from '../utils/utils';
import styles from '../../pages/litigii/litigii.module.scss';
import { variables } from '../../utils/variables';
import CChip from '../chip/chip';
import { notify } from '../../notifications/notification';

interface IEditLitigationPermissionsModal {
  litigation: ILitigation;
}
const EditLitigationPermissionsModal = (
  props: IEditLitigationPermissionsModal
) => {
  const [selectedUser, setSelectedUser] = useState({
    id: 0
  });
  const [list, setList] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    getLitigationUsers(props.litigation.id).then(({ data }) => {
      setList(data.institutionUsers);
      setUsers(data.selectedUsers);
    });
    // eslint-disable-next-line
  }, []);

  const handleDelete = (id: number) => {
    removeLitigationUser(props.litigation.id, id).then(() => {
      getLitigationUsers(props.litigation.id).then(({ data }) => {
        setUsers(data.selectedUsers);
        notify('Dosarul a fost șters cu succes.', 'success');
      });
    });
  };

  const handleAdd = () => {
    selectedUser &&
      selectedUser.id !== 0 &&
      addLitigationUser(props.litigation.id, selectedUser.id).then(() => {
        getLitigationUsers(props.litigation.id).then(({ data }) => {
          setUsers(data.selectedUsers);
          setSelectedUser({ id: 0 });
          notify('Dosarul a fost adăugat cu succes.', 'success');
        });
      });
  };
  return (
    <div className={styles.litigiiForm}>
      <p className='subheading-dark bold'>Gestionare permisiuni</p>
      <Space vertical='30px' />

      <>
        <p className='body-dark'>Alege unul sau mai multi utilizatori</p>
        <div className='col'>
          <CDropdown
            placeholder='Utilizator'
            label=''
            list={list}
            currentOption={selectedUser}
            onChange={setSelectedUser}
            visiblePhrase={el =>
              el && el.id ? `${el.firstName} ${el.lastName}` : ''
            }
          />
          <Space horizontal='30px' />
          <CButton type='submit' label='Adaugă' onClick={handleAdd} />
        </div>
      </>

      <div className={styles.listForm}>
        {users &&
          users.length > 0 &&
          users.map((user: any) => (
            <CChip
              onRemoveId={() => handleDelete(user.id)}
              label={`${user.firstName} ${user.lastName}`}
              removable
            />
          ))}
      </div>
      <Space vertical={variables.verticalSpace} />
      <div className={styles.list}>
        {users && users.length === 0 && (
          <p className='body-dark'>
            Momentan nu aveti niciun utilizator adaugat.
          </p>
        )}
      </div>
    </div>
  );
};

export default EditLitigationPermissionsModal;
